/**
 * @file sprint.form.tsx
 * @description Форма для создания и редактирования спринтов в системе управления проектами.
 * Включает поля для указания наименования спринта, статуса выполнения, даты начала и окончания.
 * Поддерживает различные статусы спринта через выпадающий список и календарный выбор дат.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/text-field, @src/types, @components/form-controls/select, @components/form-controls/date-picker]
 * @related-files [@components/form-controls/text-field/text-field.component.tsx, @components/form-controls/select/select.component.tsx, @components/form-controls/date-picker/date-picker.component.tsx]
 */

import { TextField } from '@components/form-controls/text-field';
import { BaseForm } from '@src/types';
import { Select } from '@components/form-controls/select';
import { DatePicker } from '@components/form-controls/date-picker';

export const SprintForm = ({ control }: BaseForm) => {
    return (
        <div className="flex flex-col gap-default w-[54.94vmin]">
            <div className="flex gap-default">
                <TextField name="name" label="Наименование" control={control} />

                <Select name="state" label="Статус" className="w-[26.7651vmin]" control={control} />
            </div>

            <div className="flex gap-default w-[33.28182vmin]">
                <DatePicker name="dateStart" label="Дата начала" control={control} />

                <DatePicker name="dateEnd" label="Дата окончания" control={control} />
            </div>
        </div>
    );
};
